<template>
  <div class="block-container">
    <FriedIcon class="icon" :icon="icon" />
    <FriedParagraph class="text">{{ text }}</FriedParagraph>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarInfoItem',
  props: {
    text: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
});
</script>

<style lang="scss" scoped>
.block-container {
  padding: var(--spacing-50) 0;
  display: flex;
  align-items: center;

  .icon {
    margin-right: var(--spacing-50);
  }
}
</style>
